import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import Activities from './Activities';
import Quotes from './Quotes';
import Loans from './Loans';
import InfoBox from './InfoBox';
import Grid from '@material-ui/core/Grid';
import Form from './Form';
import { fetchOrganisation } from '/actions/organisations';

class Organisation extends React.Component {
  componentWillMount = () => {
    const { match, dispatch } = this.props;
    dispatch(fetchOrganisation(match.params.orgId));
  };

  renderInfoBox = () => {
    const { organisation } = this.props;

    return (
      <Grid container spacing={24}>
        <Grid item xs={9}>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Typography variant='headline' gutterBottom>
                {organisation.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Quotes organisation={organisation} />
            </Grid>
            <Grid item xs={12}>
              <Loans organisation={organisation} />
            </Grid>
            <Grid item xs={12}>
              <Activities organisation={organisation} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <InfoBox organisation={organisation} />
        </Grid>
      </Grid>
    );
  }

  render = () => {
    const { organisation, match } = this.props;

    return !!organisation && (
      <div>
        <Route exact path={`${match.url}`} render={this.renderInfoBox} />
        <Route exact path={`${match.url}/edit`} render={(props) => <Form {...props} orgId={match.params.orgId} />} />
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const orgId = ownProps.match.params.orgId;
  const organisation = state.organisations && state.organisations[orgId];
  return { organisation };
};

const connected = connect(mapStateToProps)(Organisation);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Organisations/Organisation.js